import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';

export class CustomTranslateHttpLoader implements TranslateLoader {
    constructor(private http: HttpClient) { }

    getTranslation(lang: string): Observable<any> {
        return this.http.get(`./assets/i18n/${lang}.json`);
    }
}

export function HttpLoaderFactory(http: HttpClient) {
    return new CustomTranslateHttpLoader(http);
}